module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_troendelag_neg.8b3a94ac.svg";